/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_StepsInputs */

const en_directory_resources_contact_steps = /** @type {(inputs: Directory_Resources_Contact_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your request|Add the relevant links|Email the team`)
};

const zh_directory_resources_contact_steps = /** @type {(inputs: Directory_Resources_Contact_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`说明你的需求|附上相关链接|发送邮件给团队`)
};

/**
* | output |
* | --- |
* | "Describe your request\|Add the relevant links\|Email the team" |
*
* @param {Directory_Resources_Contact_StepsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_steps = /** @type {((inputs?: Directory_Resources_Contact_StepsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_StepsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_steps(inputs)
	return zh_directory_resources_contact_steps(inputs)
});
export { directory_resources_contact_steps as "directory.resources.contact.steps" }